import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";

import {
  GetAllSurveyUser,
  reset,
} from "../../../features/survey_user/SurveyUserSlice";

import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header, PaginationComponent } from "../../../components/admin";

import {
  faSearch,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import axios from "axios";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";

const ListSurveyUserPage = () => {
  const sortByList = [
    {
      id: "input_date",
      name: "Tanggal Buat",
    },
    {
      id: "ms.nama",
      name: "Nama Survey",
    },
  ];

  const sortTypeList = [
    {
      id: "ASC",
      name: "Paling Awal",
    },
    {
      id: "DESC",
      name: "Paling Akhir",
    },
  ];

  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("input_date");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.surveyUser);

  const token = localStorage.getItem("token");

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  useEffect(() => {
    fetchDataListSurveyUser();
  }, [dispatch, token, page, query, sortBy, sortType, row, userData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListSurveyUser();
  };

  const fetchDataListSurveyUser = () => {
    dispatch(reset());
    dispatch(
      GetAllSurveyUser({
        token: `${token}`,
        query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDelete = (id) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.delete(`${BASE_URL}survey/${id}`, {
              headers: {
                Authorization: token,
              },
            });
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!",
            });
            fetchDataListSurveyUser();
          } else {
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!",
          });
        }
      },
    });
  };

  const hitungNilaiKeseluruhan = (detail) => {
    if ((detail || []).length > 0) {
      // 4 is the max point that the detail can get
      const xP = detail?.length * 4;
      const point = detail?.map(e => e.point).reduce((a, b) => (a || 0)+(b || 0));
      const total = Math.round((point/xP)*100);

      if (total < 26) return "TIDAK PUAS";
      else if (total < 51) return "BIASA";
      else if (total < 76) return "PUAS";
      else if (total >= 76) return "SANGAT PUAS";
    }
    return "-";
  }

  return (
    <AdminLayout>
      <Header title="Survey User" />
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {sortByList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    {sortTypeList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Nama Survey</th>
                <th className="border-0">Deskripsi</th>
                <th className="border-0">Nama User</th>
                <th className="border-0">Nilai</th>
                <th className="border-0">Tanggal Dibuat</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="9" style={{ textAlign: "center" }}>
                    Loading
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={i}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    <th>{item.nama_survey}</th>
                    <th>{item.deskripsi}</th>
                    <th>{item.nama_user}</th>
                    <th>{hitungNilaiKeseluruhan(item.detail)}</th>
                    <th>
                      {moment(item.input_date).format(
                        "DD MMM YYYY HH:mm:ss"
                      )}
                    </th>
                    <th>
                      <ButtonGroup size="sm">
                        <Button as={Link} to={`/survey/detail/${item.id}/${item.id_user}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        {/* BUTTON TO DELETE */}
                        {/* <Button
                            variant="danger"
                            onClick={() => onClickDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button> */}
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="9" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default ListSurveyUserPage;
